import { useCallback } from 'react';
import {
  useMessageDispatch,
  UseMessageDispatchProps,
} from './useEddyMessaging';
import useMessageHandler from './useEddyMessaging/useMessageHandler';

type PlayMessageData = { type: 'play' };

export type UsePlayMessagingProps = Pick<UseMessageDispatchProps, 'iframe'> & {
  onPlay?: () => void;
};

export default function usePlayMessaging({
  iframe,
  onPlay,
}: UsePlayMessagingProps) {
  const dispatch = useMessageDispatch({ iframe });

  const play = useCallback(() => {
    dispatch({
      type: 'play',
    });
  }, [dispatch]);

  useMessageHandler<PlayMessageData>(
    e => {
      if (e.data.type === 'play') {
        onPlay?.();
      }
    },
    { iframe },
  );

  return { play };
}
